import { useState } from "react";

import UseNotification from "Hooks/UseNotification";

import NotificationIcon from "../Icon";
import * as S from "./styles";

const Notification = ({ notification }) => {
  const { readNotification } = UseNotification();

  const [isDescriptionOpen, setIsDescriptionOpen] = useState(false);
  const [hasRead, setHasRead] = useState(notification.read);

  const should_shorten_description = notification.description.length > 80;

  return (
    <>
      <S.Notification
        key={notification.id}
        onClick={() => {
          setIsDescriptionOpen(!isDescriptionOpen);
        }}
      >
        <NotificationIcon icon={notification?.icon} read={hasRead} />

        <S.Infos>
          <S.Title>
            <h3>{notification.title}</h3>

            <S.TimeSince read={hasRead}>
              <span>{hasRead ? notification.time_since_creation : "NOVA"}</span>
            </S.TimeSince>
          </S.Title>
          <p
            dangerouslySetInnerHTML={{
              __html: isDescriptionOpen
                ? `
                <p>${notification.description}</p>
                ${should_shorten_description ? `<strong>Ver menos</strong>` : ""}
                `
                : `
                <p>${notification.description.substring(0, 80)} ${should_shorten_description ? "..." : ""}</p>
                ${should_shorten_description ? `<strong>Saiba mais</strong>` : ""}
              `,
            }}
          />
          {isDescriptionOpen && notification.link ? (
            <S.Link href={notification.link} target="_blank">
              Acesse aqui para saber mais
            </S.Link>
          ) : null}

          {!hasRead && (
            <S.MarkAsRead
              onClick={() => {
                readNotification(notification.id);
                setHasRead(true);
              }}
            >
              Marcar como lida
            </S.MarkAsRead>
          )}
        </S.Infos>
      </S.Notification>

      <hr />
    </>
  );
};

export default Notification;
